import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private messageSource = new Subject<string>();
  private visibilitySource = new Subject<boolean>();

  message$ = this.messageSource.asObservable();
  visibility$ = this.visibilitySource.asObservable();

  private currentToastTimeout: any;  

  show(message: string, duration: number = 3000) {

    if (this.currentToastTimeout) {
      clearTimeout(this.currentToastTimeout);
      this.visibilitySource.next(false); 
    }
    
    this.messageSource.next(message);
    this.visibilitySource.next(true);

    
    this.currentToastTimeout = setTimeout(() => {
      this.visibilitySource.next(false);
    }, duration);
  }
}
